import { useCartStore } from "../../store/cart";
import "./pay-modal.css";

function fmt(cents: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
}

interface PayModalProps {
  feeRate: number;
  mode: 1 | 2;
  onCharge: (paymentMode: "cash" | "card") => void;
  onCancel: () => void;
}

export function PayModal({ feeRate, mode, onCharge, onCancel }: PayModalProps) {
  const items = useCartStore((s) => s.items);
  const cashSub = useCartStore((s) => s.cashSubtotal);
  const cartSub = useCartStore((s) => s.cartSubtotal);

  const divisor = 1 - feeRate / 100;
  const cashAmount = cashSub();

  let cardAmount: number;
  if (mode === 1) {
    cardAmount = items.reduce((sum, c) => {
      const base = c.originalPriceCents ?? c.basePriceCents;
      return sum + Math.round(base / divisor) * c.qty;
    }, 0);
  } else {
    cardAmount = cartSub();
  }

  return (
    <div>
      <div className="modal-title">How is the customer paying?</div>
      <div className="modal-sub">Select cash or card</div>

      <div className="price-grid">
        <div className="pchoice cash">
          <div className="pchoice-icon">&#x1F4B5;</div>
          <div className="pchoice-label">Cash</div>
          <div className="pchoice-amount">{fmt(cashAmount)}</div>
          <div className="pchoice-note">No fee</div>
        </div>
        <div className="pchoice card">
          <div className="pchoice-icon">&#x1F4B3;</div>
          <div className="pchoice-label">Card</div>
          <div className="pchoice-amount">{fmt(cardAmount)}</div>
          <div className="pchoice-note">+{feeRate}% fee</div>
        </div>
      </div>

      <button className="charge-btn cash" onClick={() => onCharge("cash")}>
        &#x1F4B5; Charge Cash — {fmt(cashAmount)}
      </button>
      <button className="charge-btn card" onClick={() => onCharge("card")}>
        &#x1F4B3; Charge Card — {fmt(cardAmount)}
      </button>
      <button className="modal-cancel" onClick={onCancel}>
        Cancel
      </button>
    </div>
  );
}
